import { createFileRoute } from "@tanstack/react-router";
import { Home } from "@/components/home/Home";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Royal Lumina — Best Candle Gift Store in Jaipur | Luxury Scented Candles" },
      { name: "description", content: "Discover Royal Lumina, Jaipur's premier candle gift store. Handcrafted luxury soy scented candles, artisan candle gift hampers & custom candle gifting." },
      { name: "keywords", content: "Candle gift store in Jaipur, Best candle gift in Jaipur, Royal Lumina, luxury scented candles Jaipur, candle hampers Jaipur, soy candles India" },
      { property: "og:title", content: "Royal Lumina — Best Candle Gift Store in Jaipur | Luxury Scented Candles" },
      { property: "og:description", content: "Discover Jaipur's premier luxury candle gift store. Handcrafted soy candles & artisan gifting sets." },
      { property: "og:image", content: "/candle-splash.png" },
    ],
  }),
  component: Home,
});
